export default {
  tree: {
    base: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      color: '#91a2b9',
      border: '0',
      fontSize: '12px',
      whiteSpace: 'nowrap',
    },
    node: {
      base: {
        position: 'relative',
      },
      link: {
        cursor: 'pointer',
        position: 'relative',
        padding: '0px',
        display: 'block',
      },
      activeLink: {
        background: '#e6e6e6',
        color: '#91a2b9',
      },
      toggle: {
        base: {
          position: 'relative',
          display: 'inline-block',
          verticalAlign: 'top',
          marginLeft: '-5px',
          height: '8px',
          width: '8px',
        },
        wrapper: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          margin: '-7px 0 0 -7px',
          height: '14px',
        },
        height: 14,
        width: 14,
        arrow: {
          fill: '#0E7FFE',
          strokeWidth: 0,
        },
      },
      header: {
        base: {
          display: 'inline-block',
          verticalAlign: 'top',
          color: '#91a2b9',
        },
        connector: {
          width: '2px',
          height: '12px',
          borderLeft: 'solid 1px black',
          borderBottom: 'solid 1px black',
          position: 'absolute',
          top: '0px',
          left: '-21px',
        },
        title: {
          lineHeight: '9px',
          verticalAlign: 'middle',
        },
      },
      subtree: {
        listStyle: 'none',
        paddingLeft: '7px',
      },
      loading: {
        color: '#91a2b9',
      },
    },
  },
};
